export default (context, inject) => {
  const railsHost = () => {
    if (context.env.NUXT_ENV_CAPYBARA) {
      return 'http://localhost:5002';
    }
    const prefix = context.$config.environment;
    if (prefix === 'development') {
      return 'http://localhost:3000';
    }
    if (prefix === 'production') {
      return 'https://www.bonkers.ie';
    }
    return `https://${prefix}.bonkers.ie`;
  };
  inject('railsHost', railsHost);
  context.$railsHost = railsHost;
};
